import React from 'react';
import CustomerMyBusinessByCustomerList from './CustomerMyBusinessByCustomerList';
import { CRM_COMM_PAGE_ALL_BUSINESS_BY_CUSTOMER_DETAIL_QUOTES } from '../../utils/crmCommunicationTableColumns';

export const CRM_ALL_BUSINESS_MASK_BY_CUSTOMER = 'cust028';
export const CRM_ALL_BUSINESS_MASK_DETAIL = 'cust029';

/** Všetky obchody → Podľa zákazníka (cust028): rovnaké UI ako cust025, širší scope dát. */
export default function CustomerAllBusinessByCustomerList(props) {
  return (
    <CustomerMyBusinessByCustomerList
      {...props}
      adminMode
      pageListKey="CustomerAllBusinessByCustomerList"
      pageAddKey="CustomerAllBusinessByCustomerDetail"
      maskAdd={CRM_ALL_BUSINESS_MASK_DETAIL}
      endpointBase="/api/customer_evaluations/all_business/by_customer"
      embeddedListPageKey={CRM_COMM_PAGE_ALL_BUSINESS_BY_CUSTOMER_DETAIL_QUOTES}
      adminDetailEndpointPrefix="/api/customer_evaluations/my_customers"
      partnerNameSingleLine
    />
  );
}
